import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Video::VideoContents::Component の Stimulus コントローラ。
// landIeul: VideoContents の useVisibilityCheck。「もっと見る」で 4 件ずつ非表示動画を表示し、
// 残りが無くなったらボタンを取り除く (React: isInvisibleVideoContents.length > 0 && <VideoDisplayBtn/>)。
class SiteVideoVideoContentsController extends Controller {
  static targets = ["hiddenItem", "displayBtn"];

  declare readonly hiddenItemTargets: HTMLElement[];
  declare readonly hasDisplayBtnTarget: boolean;
  declare readonly displayBtnTarget: HTMLElement;

  static NEXT_VISIBLE = 4;

  showMore(): void {
    const hidden = this.hiddenItemTargets.filter((el) =>
      el.classList.contains("VideoContents_hiddenItem"),
    );
    hidden
      .slice(0, SiteVideoVideoContentsController.NEXT_VISIBLE)
      .forEach((el) => el.classList.remove("VideoContents_hiddenItem"));

    const remaining = this.hiddenItemTargets.filter((el) =>
      el.classList.contains("VideoContents_hiddenItem"),
    );
    if (remaining.length === 0 && this.hasDisplayBtnTarget) {
      this.displayBtnTarget.remove();
    }
  }
}

// Site::Video::VideoBody のサムネイルクリック→YouTube iframe 差し替え。
class SiteVideoVideoBodyController extends Controller {
  static values = { url: String };

  declare readonly urlValue: string;

  private played = false;

  play(): void {
    if (this.played) return;
    this.played = true;

    const iframe = document.createElement("iframe");
    iframe.src = this.urlValue;
    iframe.title = "YouTube video player";
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    );
    iframe.allowFullscreen = true;

    this.element.replaceChildren(iframe);
  }
}

application.register("site--video--video-contents", SiteVideoVideoContentsController);
application.register("site--video--video-body", SiteVideoVideoBodyController);
